import { useEffect, useState } from "react";
import * as Network from "expo-network";

const useInternetStatus = () => {
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    const checkInternetConnection = async () => {
      const networkState = await Network.getNetworkStateAsync();
      setIsConnected(!!networkState.isConnected);
    };

    checkInternetConnection();

    const intervalId = setInterval(checkInternetConnection, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return isConnected;
};

export default useInternetStatus;
